import React from 'react';
import Translator from '../../../requests/apa/Translator';
import '../styles/skip-intro.css';
import {Button} from '../../../packages/components';

const SkipIntro = (props) => {
    return (
        <div className="skip-intro-container">
            <Button 
                id="skipIntroButton"
                className="skip-intro-button whenfocusable" 
                onClick={(e) => props.onClick(e)}
                data-sn-up=""
                data-sn-down=""
                data-sn-left=""
                data-sn-right=""
            >
                {Translator.get('playing_access_option_button_skipIntro', 'Omitir intro')}
            </Button>
        </div>
    );
};

export default SkipIntro;



// WEBPACK FOOTER //
// ./src/playerDomain/components/common/SkipIntro.js